var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LoadingIcon,_vm._b({staticClass:"animation-rotate opacity-transition",class:_setup.delayedDisplay.isVisible.value ? '' : 'hidden'},'LoadingIcon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }